import { render, staticRenderFns } from "./storeAnswer.vue?vue&type=template&id=6f6270fe&"
import script from "./storeAnswer.vue?vue&type=script&lang=ts&"
export * from "./storeAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./storeAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports